/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AaiDocument } from '../../asyncapi/models/AaiDocument';
import { AaiMessage } from '../../asyncapi/models/AaiMessage';
import { Aai20Document } from '../../asyncapi/v2/models/Aai20Document';
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { CombinedVisitorAdapter } from '../../combined/visitors/CombinedVisitorAdapter';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { VisitorUtil } from '../../core/util/VisitorUtil';
import { TraverserDirection } from '../../core/visitors/TraverserDirection';
import { Node } from '../../core/models/Node';
import { AaiComponents } from '../../asyncapi/models/AaiComponents';

/**
 * A command used to rename a message definition item in an AsyncAPI document.
 * @author laurent.broudoux@gmail.com
 * @param {string} oldName
 * @param {string} newName
 * @class
 * @extends AbstractCommand
 */
export class RenameMessageDefinitionCommand extends AbstractCommand {
    public _oldName : string;

    public _newName : string;

    public _references : Array<NodePath>;

    public constructor(oldName? : any, newName? : any) {
        if(((typeof oldName === 'string') || oldName === null) && ((typeof newName === 'string') || newName === null)) {
            let __args = arguments;
            super();
            if(this._oldName===undefined) this._oldName = null;
            if(this._newName===undefined) this._newName = null;
            if(this._references===undefined) this._references = null;
            if(this._oldName===undefined) this._oldName = null;
            if(this._newName===undefined) this._newName = null;
            if(this._references===undefined) this._references = null;
            (() => {
                this._oldName = oldName;
                this._newName = newName;
            })();
        } else if(oldName === undefined && newName === undefined) {
            let __args = arguments;
            super();
            if(this._oldName===undefined) this._oldName = null;
            if(this._newName===undefined) this._newName = null;
            if(this._references===undefined) this._references = null;
            if(this._oldName===undefined) this._oldName = null;
            if(this._newName===undefined) this._newName = null;
            if(this._references===undefined) this._references = null;
        } else throw new Error('invalid overload');
    }

    /**
     * 
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[RenameMessageDefinitionCommand] Executing.");
        this._references = <any>([]);
        let doc : AaiDocument = <AaiDocument>document;
        if(this.renameMessageDefinition(doc, this._oldName, this._newName)) {
            let oldRef : string = this.nameToReference(this._oldName);
            let newRef : string = this.nameToReference(this._newName);
            let finder : RenameMessageDefinitionCommand.MessageRefFinder = new RenameMessageDefinitionCommand.MessageRefFinder(oldRef);
            let messages : Array<AaiMessage> = finder.findIn(document);
            for(let index145=0; index145 < messages.length; index145++) {
                let message = messages[index145];
                {
                    /* add */(this._references.push(Library.createNodePath(message))>0);
                    message.$ref = newRef;
                }
            }
        }
    }

    /**
     * 
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[RenameMessageDefinitionCommand] Reverting.");
        if(this.renameMessageDefinition(<AaiDocument>document, this._newName, this._oldName)) {
            let oldRef : string = this.nameToReference(this._oldName);
            if(ModelUtils.isDefined(this._references)) {
                this._references.forEach(((oldRef) => {
                    return (ref) => {
                        let message : AaiMessage = <AaiMessage>ref.resolve(document);
                        message.$ref = oldRef;
                    }
                })(oldRef));
            }
        }
    }

    nameToReference(name : string) : string {
        return "#/components/messages/" + name;
    }

    renameMessageDefinition(document : AaiDocument, fromName : string, toName : string) : boolean {
        let doc20 : Aai20Document = <Aai20Document>document;
        if(this.isNullOrUndefined(doc20.components) || this.isNullOrUndefined(doc20.components.messages)) {
            return false;
        }
        if(ModelUtils.isDefined(doc20.components.getMessage(toName))) {
            return false;
        }
        let msgDef : AaiMessage = doc20.components.removeMessage(fromName);
        msgDef.rename(toName);
        doc20.components.addMessage(toName, msgDef);
        return true;
    }
}
RenameMessageDefinitionCommand["__class"] = "io.apicurio.datamodels.cmd.commands.RenameMessageDefinitionCommand";
RenameMessageDefinitionCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];



export namespace RenameMessageDefinitionCommand {

    export class MessageRefFinder extends CombinedVisitorAdapter {
        reference : string;

        messages : Array<AaiMessage> = <any>([]);

        public constructor(ref : string) {
            super();
            if(this.reference===undefined) this.reference = null;
            this.reference = ref;
        }

        public findIn(document : Document) : Array<AaiMessage> {
            VisitorUtil.visitTree(document, this, TraverserDirection.down);
            return this.messages;
        }

        /**
         * 
         * @param {AaiMessage} node
         */
        public visitMessage(node : AaiMessage) {
            if(this.accept(node)) {
                /* add */(this.messages.push(node)>0);
            }
        }

        accept(message : AaiMessage) : boolean {
            return ModelUtils.isDefined(message.$ref) && NodeCompat.equals(message.$ref, this.reference);
        }
    }
    MessageRefFinder["__class"] = "io.apicurio.datamodels.cmd.commands.RenameMessageDefinitionCommand.MessageRefFinder";
    MessageRefFinder["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];


}



